export default class Variable {

  constructor(modelData, store) {

    if (!modelData) {
      modelData = this.getDefault()
    }

    this.set(modelData)
    this.store = store
  }

  getDefault() {
    return {
      id: null,
      type: 1,
      fieldType: 2,
      example: '',
      default: '',
      customerId: null,
      isActive: true,
      isAvailableForApi: false,
      isAvailableForImport: false,
      isAvailableForSubscribersDetails: false,
      isAvailableForExport: false,
      isAvailableForDynamicGroups: false,
      isAvailableForStatisticsFilter: false,
      isAvailableForSubscribersFilter: false,
      isEditable: true,
      isSearchable: false,
      translations: {
        de: {
          name: null
        },
        en: {
          name: null
        }
      }
    }
  }

  set(data) {
    Object.assign(this, data)
  }

  getJSON() {
    return {
      id: this.id,
      type: this.type,
      fieldType: this.fieldType,
      example: this.example,
      default: this.default,
      customerId: this.customerId,
      isActive: this.isActive,
      isAvailableForApi: this.isAvailableForApi,
      isAvailableForImport: this.isAvailableForImport,
      isAvailableForSubscribersDetails: this.isAvailableForSubscribersDetails,
      isAvailableForExport: this.isAvailableForExport,
      isAvailableForDynamicGroups: this.isAvailableForDynamicGroups,
      isAvailableForStatisticsFilter: this.isAvailableForStatisticsFilter,
      isAvailableForSubscribersFilter: this.isAvailableForSubscribersFilter,
      isEditable: this.isEditable,
      isSearchable: this.isSearchable,
      translations: this.translations,
      operatorIds: this.operatorIds,
      inputId: this.inputId,
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/variable/model.js